module.exports = __webpack_public_path__ + "static/media/tick-green.c7db4416.svg";